const homeSeo = {
  title: "Custom Sportswear Manufacturer & Team Uniforms | Zarko",
  description:
    "Custom sportswear manufacturer in Sialkot, Pakistan. Factory-direct team uniforms, sublimated jerseys, and wrestling singlets for USA & global clubs.",
  canonical: "https://www.zarkosportswear.com/",
  keywords:
    "custom sportswear manufacturer, custom sports uniforms USA, sportswear manufacturer Sialkot Pakistan, factory direct team jerseys, custom wrestling singlets, sublimation teamwear",
  author: "Zarko Sportswear",
  robots: "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
  themeColor: "#0A0C16",
  image: "https://www.zarkosportswear.com/new-logo.png",
  siteName: "Zarko Sportswear",
  locale: "en_US",
  openGraph: {
    'og:title': 'Custom Sportswear Manufacturer & Team Uniforms | Zarko',
    'og:description':
      'Custom sportswear manufacturer in Sialkot, Pakistan. Factory-direct team uniforms, sublimated jerseys, and wrestling singlets for USA & global clubs.',
    'og:url': 'https://www.zarkosportswear.com/',
    'og:image': 'https://www.zarkosportswear.com/new-logo.png',
    'og:image:width': '512',
    'og:image:height': '512',
    'og:type': 'website',
    'og:site_name': 'Zarko Sportswear',
    'og:locale': 'en_US',
  },
  twitter: {
    'twitter:title': 'Custom Sportswear Manufacturer | Factory-Direct Team Uniforms | Zarko Sportswear',
    'twitter:description':
      'Custom sportswear manufacturer based in Sialkot, Pakistan, producing factory-direct team uniforms, wrestling singlets, and sublimated jerseys for USA and international clubs.',
    'twitter:card': 'summary_large_image',
    'twitter:image': 'https://www.zarkosportswear.com/new-logo.png',
    'twitter:site': '@zarkosportswear',
    'twitter:creator': '@zarkosportswear',
  },
  jsonLd: [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': 'https://www.zarkosportswear.com/#organization',
      name: 'Zarko Sportswear',
      url: 'https://www.zarkosportswear.com/',
      logo: 'https://www.zarkosportswear.com/new-logo.png',
      image: 'https://www.zarkosportswear.com/new-logo.png',
      description:
        'Custom sportswear manufacturer based in Sialkot, Pakistan, producing factory-direct sports uniforms, wrestling singlets, and sublimated team jerseys for athletic programs across the USA and worldwide.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Motra',
        addressLocality: 'Sialkot',
        addressRegion: 'Punjab',
        postalCode: '51040',
        addressCountry: 'PK',
      },
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+92-303-9200750',
          contactType: 'Customer Support',
          areaServed: ['US', 'GB', 'PK'],
          availableLanguage: ['English', 'Urdu'],
        },
      ],
      founder: [
        {
          '@type': 'Person',
          '@id': 'https://www.zarkosportswear.com/#person-atif',
          name: 'Atif Shahzad',
          jobTitle: 'Co-Founder',
          url: 'https://www.linkedin.com/in/atif-shahzad903/',
        },
        {
          '@type': 'Person',
          '@id': 'https://www.zarkosportswear.com/#person-hurairah',
          name: 'Hurairah Shahzad',
          jobTitle: 'Co-Founder',
        },
      ],
      sameAs: [
        'https://www.facebook.com/zarkosportswear',
        'https://www.instagram.com/zarko_sports.wear/',
        'https://www.linkedin.com/in/atif-shahzad903/',
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      '@id': 'https://www.zarkosportswear.com/#website',
      url: 'https://www.zarkosportswear.com/',
      name: 'Zarko Sportswear',
      description: 'Factory-direct custom sportswear manufacturer supplying teams across the USA and worldwide.',
      publisher: {
        '@id': 'https://www.zarkosportswear.com/#organization',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      '@id': 'https://www.zarkosportswear.com/#breadcrumb',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://www.zarkosportswear.com/',
        },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'How long does a custom uniform order actually take from first call to delivery?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'A standard customized tailoring order runs about 8 to 12 working days from the moment you approve the final digital design mockup. Global shipping to the USA takes an additional 3 to 5 business days via DHL or FedEx Express.',
          },
        },
        {
          '@type': 'Question',
          name: 'Is there really no minimum order, even for a single jersey?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Our standard customized runs require a minimum order quantity (MOQ) of 15 pieces per customized design layout. However, we do offer physical custom sampling/mockups for team evaluations before full production starts.',
          },
        },
        {
          '@type': 'Question',
          name: 'Are Zarko uniforms NFHS-, USA-Wrestling-, and US-Soccer-compliant?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, all our custom sports uniforms and wrestling singlets are engineered to meet the strict uniform compliance standards (including number sizing, color limits, and logo placement guidelines) set by NFHS, USA Wrestling, US Soccer, and other major governing bodies.',
          },
        },
        {
          '@type': 'Question',
          name: 'Which sports does Zarko sportswear manufacture, and what fabrics are used?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'As a leading custom sportswear manufacturer, we produce high-performance team uniforms for Soccer/Football, Basketball, Wrestling, Rugby, Cricket, Hockey, Tennis, and Running. We use export-grade fabrics including dry-fit micro-polyester, heavy-duty 4-way stretch spandex, and premium flex fleece blends.',
          },
        },
        {
          '@type': 'Question',
          name: 'Can I order matching shorts, sideline jackets, warm-ups, and bags in the same design?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Absolutely! We synchronize dye batches and design blueprints across all product types (jerseys, shorts, hoodies, tracksuits, bags) to ensure your entire squad has a cohesive, 100% matching team look.',
          },
        },
      ],
    },
  ],
};

export default homeSeo;
